import React from 'react';
import gettext from '@eb/gettext';

import { Button } from '@eb/eds-button';

const ForgotPasswordLink = ({ onClick, isDisabled, dataTestId }) => (
    <div className="eds-text-bm eds-text-weight--heavy">
        <Button
            type="button"
            style="anchor"
            onClick={onClick}
            disabled={isDisabled}
            data-testid={`${dataTestId}-button`}
        >
            {gettext('Forgot password?')}
        </Button>
    </div>
);

export default ForgotPasswordLink;
